<script setup lang="ts">
import { useUserStore } from "@/store/user";
import { computed } from "vue";
import { useRoute } from "vue-router";
// import { isApp, isAideApp } from "@/utils/bridge/index.js";

const userStore = useUserStore();
const route = useRoute();

// 计算组件key，包含页面刷新key
const componentKey = computed(() => {
  const routeName = route.name as string;
  const refreshKey = userStore.getPageRefreshKey(routeName);
  return `${routeName}-${refreshKey}`;
});

// // 是否为 app 内（臻甜瓜分期（Android）& 甜瓜好用（iOS））
// const isAppInner = computed(() => isApp() || isAideApp());
// // 是否为 tcmelon.com 的线上域名（公众号）
// const isGzhOnline = computed(() => window.location.hostname.includes("tcmelon.com"));
// v-if="isAppInner || isGzhOnline"

</script>

<template>
  <!-- <RouterView/> -->
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" v-if="$route.meta?.keepAlive" :key="componentKey" />
    </keep-alive>
    <component :is="Component" v-if="!$route.meta?.keepAlive" />
  </router-view>
</template>

<style scoped></style>
